export default __webpack_public_path__ + "static/logo-6648d0a92e2297620e7ee224cf9e6709.png";